// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  matchId: __t.u64().primaryKey().name("match_id"),
  worldId: __t.u64().name("world_id"),
  siteId: __t.u64().name("site_id"),
  state: __t.string(),
  teamSize: __t.u8().name("team_size"),
  round: __t.u8(),
  winsA: __t.u8().name("wins_a"),
  winsB: __t.u8().name("wins_b"),
  draws: __t.u8(),
  consecutiveDraws: __t.u8().name("consecutive_draws"),
  zoneX: __t.f32().name("zone_x"),
  zoneZ: __t.f32().name("zone_z"),
  zoneR: __t.f32().name("zone_r"),
  relayX: __t.f32().name("relay_x"),
  relayZ: __t.f32().name("relay_z"),
  relayR: __t.f32().name("relay_r"),
  stagingAx: __t.f32().name("staging_ax"),
  stagingAz: __t.f32().name("staging_az"),
  stagingBx: __t.f32().name("staging_bx"),
  stagingBz: __t.f32().name("staging_bz"),
  capA: __t.f32().name("cap_a"),
  capB: __t.f32().name("cap_b"),
  capAt: __t.timestamp().name("cap_at"),
  vacantSince: __t.timestamp().name("vacant_since"),
  roundStartedAt: __t.timestamp().name("round_started_at"),
  roundEndsAt: __t.timestamp().name("round_ends_at"),
  relayActiveAt: __t.timestamp().name("relay_active_at"),
  readyDeadline: __t.timestamp().name("ready_deadline"),
  matchDeadline: __t.timestamp().name("match_deadline"),
  gen: __t.u32(),
  winner: __t.string(),
  result: __t.string(),
  createdAt: __t.timestamp().name("created_at"),
  finishedAt: __t.timestamp().name("finished_at"),
  updatedAt: __t.timestamp().name("updated_at"),
});
